import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=30168d4e&scoped=true&"
import script from "./SettingsNav.vue?vue&type=script&lang=js&"
export * from "./SettingsNav.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=30168d4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30168d4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemIcon,VListItemTitle})
